module.exports = __webpack_public_path__ + "img/handbag-fill.2e72e1e0.svg";